// Don't put env variables in this file put them in env.ts instead. This is only because there are some extra implications to playwright / sentry.
export const SENTRY_ENABLED = process.env.SENTRY_ENABLED === "true";
export const FLUID_CDN_URL = "https://assets.fluid.app";

export const ADDITIONAL_VALID_EMAIL_TLDS = ["app"];

export const GOOGLE_ADDRESS_VALIDATION_URL =
  "https://addressvalidation.googleapis.com/v1:validateAddress";

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const languages = [
  {
    id: 51848956,
    iso: "es",
    name: "Español (Spanish)",
  },
  {
    id: 980190962,
    iso: "en",
    name: "English",
  },
  {
    id: 1018350796,
    iso: "pt",
    name: "Português (Portuguese)",
  },
  {
    id: 113629430,
    iso: "pl",
    name: "Polski (Polish)",
  },
  {
    id: 1018350797,
    iso: "he",
    name: "עברית (Hebrew)",
  },
  {
    id: 1018350798,
    iso: "nl",
    name: "Nederlands (Dutch)",
  },
  {
    id: 1018350799,
    iso: "de",
    name: "Deutsch (German)",
  },
  {
    id: 1018350800,
    iso: "hu",
    name: "Magyar (Hungarian)",
  },
  {
    id: 1018350801,
    iso: "id",
    name: "Bahasa Indonesia (Indonesian)",
  },
  {
    id: 1018350802,
    iso: "it",
    name: "Italiano (Italian)",
  },
  {
    id: 298486374,
    iso: "fr",
    name: "Français (French)",
  },
  {
    id: 281110143,
    iso: "ru",
    name: "Русский (Russian)",
  },
  {
    id: 1018350795,
    iso: "ja",
    name: "日本語 (Japanese)",
  },
  {
    id: 1018350803,
    iso: "zh_CN",
    name: "简体中文 (Chinese - Simplified)",
  },
  {
    id: 1018350810,
    iso: "zh_TW",
    name: "繁體中文 (Chinese - Traditional)",
  },
  {
    id: 1018350804,
    iso: "tl",
    name: "Tagalog",
  },
  {
    id: 1018350805,
    iso: "th",
    name: "ไทย (Thai)",
  },
  {
    id: 1018350806,
    iso: "ko",
    name: "한국어 (Korean)",
  },
  {
    id: 1018350807,
    iso: "el",
    name: "Ελληνικά (Greek)",
  },
  {
    id: 1018350808,
    iso: "ro",
    name: "Română (Romanian)",
  },
  {
    id: 1018350809,
    iso: "tr",
    name: "Türkçe (Turkish)",
  },
];
